/*
 * @Author: 肖玲
 * @Date: 2023-02-15 16:31:30
 * @LastEditTime: 2023-02-16 10:46:46
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\business-order\order-manage\index.js
 * 订单/发货管理
 */
import orderManageRouter from './modules/orderManageRouter'
import cooperativeManagementRouter from './modules/cooperativeManageRouter'
const orderManageRouters = [].concat(orderManageRouter, cooperativeManagementRouter)
export default orderManageRouters